<div class="admin admin-page admin-page-dashboard">

  <div class="page-header">
    <h2 class="page-title">{{'Dashboard' | translate}}</h2>
  </div>

  <div class="page-body">

    <div class="row mt-3">

      <div [ngClass]="canManageCompanies ? 'col-6' : 'col-12'">

        <div class="card mb-3">

          <div class="card-header">
            <h5 class="card-title p-0 m-0">{{'Student profiles' | translate}} ({{view.studentprofiles.totalItems}})</h5>
          </div>
          <div class="card-body">

            <app-loader *ngIf="view.studentprofiles.isLoading"></app-loader>

            <table *ngIf="!view.studentprofiles.isLoading" class="table table-striped">
              <thead>
              <tr>
                <td>{{'Image' | translate}}</td>
                <td>{{'Name' | translate}}</td>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let row of view.studentprofiles.data">
                <td><img class="img-fluid img-64" *ngIf="row.avatarUri" [src]="row.avatarUri" /></td>
                <td><a href="javascript:void(0)" (click)="openStudentProfileModal(row)">{{row.firstName}} {{row.lastName}}</a></td>
              </tr>
              </tbody>

            </table>

          </div>
          <div class="card-footer">
            <a [routerLink]="'/admin/studentprofiles'" class="btn btn-block btn-primary">
              {{'View all' | translate}}
            </a>
          </div>

        </div>

      </div>

      <div class="col-6" *ngIf="canManageCompanies">

        <div class="card mb-3">

          <div class="card-header">
            <h5 class="card-title p-0 m-0">{{'Companies' | translate}} ({{view.companies.totalItems}})</h5>
          </div>
          <div class="card-body">

            <app-loader *ngIf="view.companies.isLoading"></app-loader>

            <table *ngIf="!view.companies.isLoading" class="table table-striped">
              <thead>
                <tr>
                  <td>{{'Image' | translate}}</td>
                  <td>{{'Name' | translate}}</td>
                </tr>
              </thead>
              <tbody>
              <tr *ngFor="let row of view.companies.data">
                <td><img class="img-fluid img-64" *ngIf="row.avatarUri" [src]="row.avatarUri" /></td>
                <td><a [routerLink]="'/admin/companies/' + row.id">{{row.name}}</a></td>
              </tr>
              </tbody>

            </table>

          </div>
          <div class="card-footer">
            <a [routerLink]="'/admin/companies'" class="btn btn-block btn-primary">
              {{'View all' | translate}}
            </a>
          </div>

        </div>

      </div>

    </div>

    <div class="row">

      <div class="col-6">

        <div class="card mb-3">

          <div class="card-header">
            <h5 class="card-title p-0 m-0">{{'Vacancies' | translate}} ({{view.jobs.totalItems}})</h5>
          </div>
          <div class="card-body">

            <app-loader *ngIf="view.jobs.isLoading"></app-loader>

            <table *ngIf="!view.jobs.isLoading" class="table table-striped">
              <thead>
              <tr>
                <td>{{'Date' | translate}}</td>
                <td>{{'Title' | translate}}</td>
                <td>{{'Company' | translate}}</td>
                <td>{{'Logo' | translate}}</td>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let row of view.jobs.data">
                <td>{{row.createdOn | date: "dd-MM-YYYY"}}</td>
                <td><a [routerLink]="'/admin/jobs/' + row.id">{{row.title}}</a></td>
                <td>{{row.company.name}}</td>
                <td><img class="img-32" [src]="row.company.avatarUri" /></td>
              </tr>
              </tbody>

            </table>

          </div>
          <div class="card-footer">
            <a [routerLink]="'/admin/jobs'" class="btn btn-block btn-primary">
              {{'View all' | translate}}
            </a>
          </div>

        </div>

      </div>

    </div>

  </div>

</div>
